import { ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";

import styled from "styled-components";

import { ArrowLeftOutlined } from "@ant-design/icons";

import { Button } from "antd";

import { colors, fonts } from "@app/theme.ts";

interface CmtPageProps {
  title?: ReactNode;
  eyebrow?: ReactNode;
  subtitle?: ReactNode;
  extra?: ReactNode;
  children: ReactNode;
  goBack?: boolean;
}

const StyledHeader = styled.header`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.75rem;
`;

const StyledEyebrow = styled.div`
  color: ${colors.pink};
  font-family: ${fonts.hand};
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1;
`;

const StyledTitle = styled.h1`
  margin: 0.25rem 0 0;
  color: ${colors.navy};
  font-size: 2.25rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.15;
`;

const StyledSubtitle = styled.p`
  margin: 0.5rem 0 0;
  color: ${colors.grey2};
`;

const StyledBackButton = styled(Button)`
  padding-inline: 0;
  margin-bottom: 1rem;
  color: ${colors.grey2};
`;

export const CmtPage = ({
  title,
  eyebrow,
  subtitle,
  extra,
  children,
  goBack,
}: CmtPageProps) => {
  const navigate = useNavigate();

  return (
    <>
      {goBack && (
        <StyledBackButton
          type="link"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(-1)}
        >
          <span>
            <FormattedMessage id="app.back" defaultMessage="Back" />
          </span>
        </StyledBackButton>
      )}
      {(title ?? extra) && (
        <StyledHeader>
          <div>
            {eyebrow && <StyledEyebrow>{eyebrow}</StyledEyebrow>}
            {title && <StyledTitle>{title}</StyledTitle>}
            {subtitle && <StyledSubtitle>{subtitle}</StyledSubtitle>}
          </div>
          {extra}
        </StyledHeader>
      )}
      {children}
    </>
  );
};
